import {type Capacitor} from '@capacitor/core';

export type CustomFile = File & {id?: string};

export enum MediaType {
    Video = 'Video',
    File = 'File',
    Image = 'Image',
}

/**
 * localSrc is generated using `convertFileSrc` which converts a device filepath
 * into a Web View friendly path.
 *
 * See https://capacitorjs.com/docs/basics/utilities#convertfilesrc
 */
export interface CapacitorFile extends File {
    localSrc?: ReturnType<typeof Capacitor.convertFileSrc>;
    id?: string;
}

interface PersistedProps {
    temporaryFileUrl: string;
}

export interface PersistedVideo extends PersistedProps {
    duration: number;
    height: number;
    persistenceId: string;
    thumbnailUrl: string;
    transcoding: boolean;
    id?: string;
    videoId: string;
    videoUrl: string;
    width: number;
    mediaType: MediaType.Video;
}

interface ImageInfo {
    url: string;
    width: number;
    height: number;
}

export interface PersistedImage extends PersistedProps {
    big: ImageInfo;
    thumbnail: ImageInfo;
    id?: string;
    imageId: string;
    objectUrlSmall: string;
    url?: string;
    expiration: string;
    mediaType: MediaType.Image;
    height: number;
    width: number;
    secret?: {
        expires: string;
        key: string;
        path: string;
        prefix: string;
    };
}

interface PersistedFile extends PersistedProps {
    id?: string;
    fileId: string;
    mediaType: MediaType.File;
}

// TODO: Extend NonpersistedObject and PersistedObject with {isPersisted: boolean}
// and update FileTaggingModal.
export interface NonpersistedObject {
    mediaType: MediaType;
}

export type PersistedObject = PersistedImage | PersistedVideo | PersistedFile;
